import { render, staticRenderFns } from "./CrmIcon.vue?vue&type=template&id=3494d847"
import script from "./CrmIcon.vue?vue&type=script&lang=js"
export * from "./CrmIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports